import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from "@angular/material";

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-customer-orders',
  templateUrl: './customer-orders.component.html',
  styleUrls: ['./customer-orders.component.css']
})
export class CustomerOrdersComponent implements OnInit {
  public loading = false;
  public customerList: Array<any> = [];
  public Options: any = {};
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 1000;
  public search: string = "";
  public sortColumnName = "id";
  public sortDirection = "desc";
  public filterText: string;
  public storeId: string;
  public csvUrl: string;
  public locationArr = [
    'front',
    'back',
    'left',
    'right'
  ]
  constructor(private CommonService: CommonService,
    private router: Router,
    private activateroute: ActivatedRoute,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.storeId = this.activateroute.snapshot.params["storeId"];
    this.getStoreCustomerData();
  }

  getStoreCustomerData = function () {
    this.loading = true;
    this.Options = {
      id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page,
      store_id: this.storeId
    };
    if (this.filterText) {
      this.Options.search = this.filterText;
    }
    this.CommonService.apiService(
      "POST",
      "store/clients",
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.customerList = response.data.records;//.filter(x=>x.purchase_date!=null);  
            this.total = response.data.total;
            this.current_page = response.data.current_page;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  // Assign a product-image when mockup is not available
  getMockupImage(mockupData: any, projectIndex: any, order: any){
    let imageUrl: string = '';
    if(mockupData){
      if(mockupData[projectIndex]){
        const mockupDataItem = mockupData[projectIndex];
        const mockupKey = Object.keys(mockupDataItem)[0];
        if (mockupDataItem[mockupKey].mockup) {
          imageUrl = mockupDataItem[mockupKey].mockup
        }
      }
    }

    if(!imageUrl){
      if(order){
        if(order.product[0]){
          if(order.product[0].image){
            imageUrl = order.product[0].image;
          }
        }
      }
    }
    
    return imageUrl;
  }

  trackByFn(index: any, item: any) {
    return index;
  }
  backToList() {
    this.router.navigate(['/stores']);
  }

  goToPage(n: number): void {
    this.page = n;
    this.getStoreCustomerData();
  }

  onNext(): void {
    this.page++;
    this.getStoreCustomerData();
  }

  onPrev(): void {
    this.page--;
    this.getStoreCustomerData();
  }

  printCustomerOrders() {
    setTimeout(() => {
      window.print();
    }, 1000);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/customer-orders/customer-orders.component.ts